<template>
  <a-page
    id="room-type-management-app"
    :image_source="image_source"
    :image_height="image_height"
  >
    <template v-slot:header_options>
      <v-btn
        v-if="pax_supplement_visible"
        color="secondary"
        rounded
        @click="pax_supplements_dialog = true"
        class="mr-2"
      >
        <v-icon left>mdi-account-outline</v-icon>
        {{ $t("Supplements") }}
      </v-btn>
    </template>
    <template v-if="is_all_hotels">
      <a-hotel-selector-page></a-hotel-selector-page>
    </template>
    <template v-else>
      <v-tabs
        class="px-1"
        background-color="transparent"
        slider-size="2"
        v-model="tab"
        dark
        grow
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          {{ $t("categories") }}
        </v-tab>
        <v-tab>
          {{ $t("Planning") }}
        </v-tab>
        <v-tab>
          {{ $t("Mapping") }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <room-type-management-app
            ref="room-type-management-app"
          ></room-type-management-app>
        </v-tab-item>
        <v-tab-item>
          <a-room-type-ref-prices />
        </v-tab-item>
        <v-tab-item>
          <a-room-type-competitor-mapping />
        </v-tab-item>
      </v-tabs-items>
    </template>

    <a-room-type-management-pax-supplements v-model="pax_supplements_dialog" />
  </a-page>
</template>

<script>
import aPage from "@/components/aPage";
import roomTypeManagementApp from "@/components/app/settings/roomTypeManagementApp.vue";
import aHotelSelectorPage from "@/components/selector/aHotelSelectorPage.vue";
import aRoomTypeCompetitorMapping from "@/components/settings/aRoomTypeCompetitorMapping.vue";
import aRoomTypeManagementPaxSupplements from "@/components/settings/aRoomTypeManagementPaxSupplements.vue";
import aRoomTypeRefPrices from "@/components/settings/aRoomTypeRefPrices.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    aPage,
    roomTypeManagementApp,
    aHotelSelectorPage,
    aRoomTypeManagementPaxSupplements,
    aRoomTypeRefPrices,
    aRoomTypeCompetitorMapping
  },
  data: () => ({
    image_source: "/img/header-2.jpg", //Mandatory path
    subscribed_modules: ["roomtype_types_mapped", "roomtype_types_available"],
    tab: 0,
    pax_supplements_dialog: false
  }),
  computed: {
    image_height() {
      return this.is_all_hotels ? 380 : 113;
    },
    is_all_hotels: function() {
      return this.current_hotel && this.current_hotel.children_number > 0;
    },
    pax_supplement_visible() {
      return (
        this.current_hotel &&
        this.current_user &&
        this.current_hotel.permissions &&
        this.current_hotel.permissions.rms_pax_supplement &&
        this.current_user.permissions &&
        this.current_user.permissions.rms_pax_supplement
      );
    },
    ...mapGetters({
      current_hotel: "current_hotel",
      current_user: "current_user"
    })
  }
};
</script>
<style>
.hotel_selected {
  background-color: #0084c8 !important;
}
</style>
